export enum AdminAddStepTemplateFormItemName {
  Type = "type",
  Name = "name",
  Description = "description",
  MessageText = "messageText",
  QuestionnaireId = "questionnaireId",
}
